import React, { Component } from "react";
import Loader from "../../../../../Common/Component/Loader";
import { DatePicker, message,Modal, Select } from "antd";
import moment from "moment-timezone"; 
import { map, isEmpty } from "lodash";
import _ from 'lodash';
import { formatToCurrency } from "../../../../../../Tools/formatToCurrency";

import * as yup from "yup";
import axios from "../../../../../../Lib/axios";

const { Option } = Select;
var confirm = true;

class AddNewInvoice extends Component {
  state = {
    loader: false,
    invoice_date:null,
    due_date: '',
    rows: [{ service_uuid: '', type: '', date: '', description: '',quantity:1, price: '', taxChecked: false, tax: '',isEditRow:false }],
    description: '',
    serviceOrderNumberList: {},
    total: '',
    sales_tax: '',
    balance_due: '',
    refund_amount:'',
    quantity:1,
    amount_received: '0',
    serviceOrder: {},
    addInvoice: {},
    btn_active: false,
    isApprove: false,
    errors: {},
    description_data: [],
    service_order_uuid: '',
    serviceList: [],
    changedLineItemIndex: -1,
    workOrderDetail:{},
    service_uuid:'',
    selectWorkOrder:false,
    invoiceDetail: {},
    showDelete:false,
    selectedDeletedItem:null,
    selectedDeletedType:null,
    deletedWorkOrder:[],
    is_manual_invoice:true,
    isGenerateInvoiceVisible:false,
    did_click:false
  }

  componentDidMount = () => {
    this.setState({ loader: true })
    if(this.props.invoice_uuid){
      this.props.getInvoiceById(this.props.invoice_uuid)
    }
    if(this.props.service_order_uuid){
      this.props.getInvoiceDescription(this.props.service_order_uuid)  
    }
    this.props.getServiceOrderNumberList({ user__uuid: this.props.customerId })

  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { serviceOrderNumberList, serviceOrder, addInvoice,workOrderDetail,invoiceDetail } = this.state;
    // message.destroy()
    // if(!this.props.invoice_uuid){
    //   this.setState({
    //     rows: [{ service_uuid: '', type: '', date: '', description: '',quantity:1, price: '', taxChecked: false, tax: '',isEditRow:true }],
    //     service_order_uuid:'',
    //     amount_received:'',
    //     invoice_date:null,
    //     due_date: '',
    //     total: '',
    //     sales_tax: '',
    //     balance_due: '',
    //     refund_amount:'',
    //   })
    // }
    if (Object.keys(nextProps?.Invoice?.errors).length > 0
      && JSON.stringify(nextProps?.Invoice?.errors) !== JSON.stringify(this.props?.Invoice?.errors)) {
      this.setState({loader: false})
      message.error('Something went wrong', 10)
    }

    //get service order number list
    if (Object.keys(nextProps?.Invoice?.serviceOrderNumberList).length > 0
      && JSON.stringify(nextProps?.Invoice?.serviceOrderNumberList) !== JSON.stringify(serviceOrderNumberList)) {
      this.setState({ serviceOrderNumberList: nextProps?.Invoice?.serviceOrderNumberList });
      this.setState({ loader: false })
    }

    // get service order
    if (Object.keys(nextProps?.ServiceOrder?.viewOrder).length > 0
      && JSON.stringify(nextProps?.ServiceOrder?.viewOrder) !== JSON.stringify(serviceOrder)) {
      this.setState({ serviceOrder: nextProps?.ServiceOrder?.viewOrder });
      this.setState({ loader: false })
    }

    // add invoice
    if (Object.keys(nextProps?.Invoice?.addInvoice).length > 0
      && JSON.stringify(nextProps?.Invoice?.addInvoice) !== JSON.stringify(addInvoice)) {
      this.setState({ addInvoice: nextProps?.Invoice?.addInvoice }, () => {
        if (this.state.isApprove) {
          this.props.finalizeInvoice(this.state?.addInvoice?.uuid)
          this.setState({ isApprove: false })
        }
        this.addLineItems()
      });
      this.setState({ loader: false })
    }

    //Process Invoice
    if (Object.keys(nextProps.InvoiceProcess?.data).length > 0 && nextProps.InvoiceProcess?.data !== this.props.InvoiceProcess?.data) {
      message.success(nextProps.InvoiceProcess.data?.message, 10);
      this.setState({
        loader: false,
      });
      nextProps.onChangeView(0);
    }

    if (Object.keys(nextProps.InvoiceProcess?.errors).length > 0 && nextProps.InvoiceProcess?.errors !== this.props.InvoiceProcess?.errors) {
      // display error messsage
      this.setState({ loader: false})
      if (nextProps.InvoiceProcess?.errors?.detail) {
        message.error(nextProps.InvoiceProcess?.errors?.detail, 10);
      }
    }

    //Get Invoice Description
    if (Object.keys(nextProps?.InvoiceDescription?.data).length > 0
      && nextProps?.InvoiceDescription?.data !== this.props.InvoiceDescription.data) {
      this.setState({
        loader: false,
        description_data: nextProps?.InvoiceDescription?.data
      })
    }
    //Get Invoice Description
    if (Object.keys(nextProps?.Invoice?.addManualInvoice).length > 0 && nextProps?.Invoice?.addManualInvoice !== this.props.Invoice.addManualInvoice) {
      this.setState({
        loader: false,
      })
      // if (this.state.isApprove) {
      //   this.props.invoiceProcess({multiple_invoices_uuid:nextProps?.Invoice?.addManualInvoice?.invoice_uuid})
      //   this.setState({ isApprove: false })
      // }
      nextProps.onChangeView(0)
      message.success(` ${nextProps?.Invoice?.addManualInvoice?.message}`, 10);
    }

    // add invoice
    if (Object.keys(nextProps?.Invoice?.invoiceDetail)?.length > 0
      && JSON.stringify(nextProps?.Invoice?.invoiceDetail) !== JSON.stringify(invoiceDetail)) {
      const invoiceDetail = nextProps?.Invoice?.invoiceDetail;
      const is_manual_invoice = nextProps?.Invoice?.invoiceDetail?.is_manual_invoice

      if (invoiceDetail?.line_items?.length > 0) {
        for (let index = 0; index < invoiceDetail?.line_items?.length; index++) {
          const descriptionItem = nextProps?.InvoiceDescription?.data?.data?.find(x => x.item === invoiceDetail?.line_items[index].description && x.type === invoiceDetail?.line_items[index].item_type);
          if (!descriptionItem) {
            invoiceDetail.line_items[index].other_description = invoiceDetail.line_items[index].sub_description;
            invoiceDetail.line_items[index].description = invoiceDetail.line_items[index].sub_description;
          }
        }
      }
      const serviceList = serviceOrderNumberList?.data?.find(x => x.uuid === invoiceDetail?.service_order?.uuid)
      let filterList = serviceList?.services.filter(function( obj ) { 
        return obj.invoice_status === ''
        // return obj.status==='cancelled'?obj.bill_for_cancelization===true && obj.is_auto_invoice_genrated ===false && obj.is_manual_invoice_generated === false:obj.is_auto_invoice_genrated ===false && obj.is_manual_invoice_generated === false;
      });
      this.setState({
        is_manual_invoice,
        invoiceDetail, serviceOrder: invoiceDetail?.service_order,
        description: invoiceDetail?.notes,
        balance_due: invoiceDetail?.balance_due,
        sales_tax: invoiceDetail?.sales_tax,
        amount_received: invoiceDetail?.amount_received,
        credit_memo_amount_applied: invoiceDetail?.credit_memo_amount_applied,
        total: invoiceDetail?.total,
        invoice_date: invoiceDetail?.invoice_date,
        due_date: invoiceDetail?.due_date,
        service_order_uuid: invoiceDetail?.service_order?.uuid,
        service_order_number: invoiceDetail?.service_order?.service_order_number,
        serviceList: filterList
      }, () => this.setLineItems());
    }

    // get sales tax
    if (Object.keys(nextProps?.Invoice?.getSalesTax).length > 0
    && JSON.stringify(nextProps?.Invoice?.getSalesTax) !== JSON.stringify(this.props?.Invoice?.getSalesTax)) {
      const {rows, changedLineItemIndex} = this.state;
      rows[changedLineItemIndex].tax = nextProps?.Invoice?.getSalesTax?.total_tax
      this.setState({rows}, () => this.calculateTotal())
      this.setState({ loader: false })
    }
    // get work order details
    if (Object.keys(nextProps?.WorkOrderDetail?.data).length > 0
    && this.state.selectWorkOrder===true) {
      this.setState({ workOrderDetail: nextProps?.WorkOrderDetail?.data?.calculated_price })
      let date = nextProps?.WorkOrderDetail?.data?.date;
      let data = nextProps?.WorkOrderDetail?.data?.calculated_price;
      let description= nextProps?.InvoiceDescription?.data.data;
      const { rows,service_uuid,invoice_date } = this.state;
      this.setState({ rows })
      //add-on services
      data.add_ons.recurring_addon_items.map(function(item,index){
        let type = description.find(x => x.item === item.name.charAt(0).toUpperCase() + item.name.slice(1))
        axios.post(`/invoice-line-item/get-tax-amount/`, {service_uuid: service_uuid, amount: item.price*(item.quantity?item.quantity:1), item_type: type?type.type:"service"}).then((response) => {
          rows.push({ service_uuid: service_uuid, type: type?type.type:"service", date: date, description:item.name.charAt(0).toUpperCase() + item.name.slice(1),quantity:1, price: item.price, taxChecked: false, tax: response.data.total_tax,sub_description:'',isEditRow:true })
        }).catch(error => {
          message.error(`Error occurred while calculating the Tax.`, 30);
        });
      })
      //cleaning services
      data.cleaning_areas.items.map(function(item,index){
        let type = description.find(x => x.item === item.area.charAt(0).toUpperCase() + item.area.slice(1))
        axios.post(`/invoice-line-item/get-tax-amount/`, {service_uuid: service_uuid, amount: item.price*(item.quantity?item.quantity:1), item_type: type?type.type:"service"}).then((response) => {
          rows.push({ service_uuid: service_uuid, type: type?type.type:"service", date: date, description:item.area.charAt(0).toUpperCase() + item.area.slice(1),quantity:1, price: item.price, taxChecked: false, tax: response.data.total_tax, sub_description:'',isEditRow:true })
        }).catch(error => {
          message.error(`Error occurred while calculating the Tax.`, 30);
        });
      })
      //one time charges
      data.one_time_charges.one_time_items.map(function(item,index){
        let type = "service"
        axios.post(`/invoice-line-item/get-tax-amount/`, {service_uuid: service_uuid, amount: item.price*(item.quantity?item.quantity:1), item_type: type}).then((response) => {
          rows.push({ service_uuid: service_uuid, type: type, date: date, description:`One-time charge`, price: item.price, taxChecked: false, tax: response.data.total_tax, sub_description:item.name,isEditRow:true })
        }).catch(error => {
          message.error(`Error occurred while calculating the Tax.`, 30);
        });
      }) 
      //miscallaneous services
      if(Object.keys(data.miscallaneous_services).length !== 0 || data.miscallaneous_services.length>0){
        data.miscallaneous_services.map(function(item,index){
          let type = item.mis_type;
          axios.post(`/invoice-line-item/get-tax-amount/`, {service_uuid: service_uuid, amount: item.price*(item.quantity?item.quantity:1), item_type: type}).then((response) => {
            rows.push({ service_uuid: service_uuid, type: type, date: date, description:`Miscellaneous/${item.item}`, price: item.price, taxChecked: false, tax: response.data.total_tax, sub_description:item.item,isEditRow:true,quantity:1 })
          }).catch(error => {
            message.error(`Error occurred while calculating the Tax.`, 30);
          });
        })
      }
      //regular services
      axios.post(`/invoice-line-item/get-tax-amount/`, {service_uuid: service_uuid, amount: data.service_base_price, item_type:"service"}).then((response) => {
        rows.push({ service_uuid: service_uuid, type:"service", date: date, description:"Regular Service",quantity:1, price: data.service_base_price, taxChecked: false, tax: response.data.total_tax, sub_description:'',isEditRow:true })
      }).catch(error => {
        message.error(`Error occurred while calculating the Tax.`, 30);
      });
      setTimeout(() => {
        let arr = rows.filter(function( obj ) { 
          return obj.type !=='';
        });
        this.setState({rows:arr})
        this.calculateTotal();
        this.setState({ loader: false })
      }, 10000);
    }
  }

  setLineItems = () => {
    const { invoiceDetail } = this.state;
    const rows = []
    map(invoiceDetail?.line_items, (x) => {
      rows.push({
        uuid: x.uuid, 
        service_uuid: x?.service_uuid,
        type: x.item_type,
        date: x.date, 
        description: x.description, 
        price: x.price,
        quantity:x.quantity,
        // taxChecked: x.tax_percent ? true : false,
        tax: x.tax || '0',
        isEditRow: false,
        other_description: x.sub_description, 
        service_code : x.service_code
      })
    })
    this.setState({ rows }, () => { this.calculateTotal() })
  }

    // toggle delete modal
    toggleDeleteModal = (item,type) => {
      this.setState({selectedDeletedItem:item,selectedDeletedType:type})
      this.setState((prevState) => ({ showDelete: !prevState.showDelete }))
    }

  search = (nameKey, myArray) => {
    for (var i=0; i < myArray.length; i++) {
      if (myArray[i].name === nameKey) {
        return myArray[i];
      }
    }
  }

  // add line items
  addLineItems = () => {
    const { addInvoiceLineItem, onChangeView, getInvoiceList } = this.props;
    const { addInvoice, rows } = this.state;
    let arr = [];
    this.setState({ loader: true })
    map(rows, x => {
      // const per_idx = x?.tax?.indexOf('%');
      // const org_tax = 2.90
      // const org_tax = x?.taxChecked ? per_idx > -1 ? x?.tax?.replace('%', '') : x?.tax : 0;
      // const tax = (parseFloat(x.price) * (org_tax / 100))
      arr.push(addInvoiceLineItem({
        service_uuid: x?.service_uuid,
        item_type: x.type,
        date: x.date ? this.localToUTC(x.date).format('YYYY-MM-DD') : null,
        description: x.description,
        sub_description: x?.description === 'other' ? x.other_description : '',
        price: x.price,
        quantity:x.quantity?x.quantity:1,
        // tax: tax || 0,
        // tax_percent: x.tax || 0,
        invoice_uuid: addInvoice?.uuid
      }))
    })

    Promise.all(arr).then((response) => {
      if (!isEmpty(response)) {
        onChangeView(0)
        getInvoiceList()
      }
    })
  }

  // convert date time from utc to local time
  UTCToLocal = (date) => {
    let stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local();
  }

  // convert date time from local to utc
  localToUTC = (date) => {
    return moment.utc(date)
  }

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // on invoice detail change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value })
    const {rows} = this.state;
    // if(e.target.name==="invoice_date" && this.state.rows[0].service_uuid!==""){
    //   rows.map(function(item,i){
    //     item.date=e.target.value
    //   })
    //   this.setState({
    //     rows
    //   })
    // }
  }

  // on item row change
  onRowDataChange = (e, index, type) => {
    const { rows } = this.state;
    if(rows.some(rows => rows.service_uuid === e.target.value)){
      let arr = rows.filter(function( obj ) { 
        return obj.type !=='';
      });
      this.setState({rows:arr}) 
      alert("You have already selected that Work Order! Please select another Work Order!");
    }else{
      const value = type === 'bool' ? e.target.checked : e.target.value;
      Object.assign(rows[index], { [e.target.name]: value })
      this.setState({ rows, changedLineItemIndex: index }, () => {
        const {rows} = this.state;
        if (rows[index].service_uuid && rows[index].price && rows[index].type) {
          this.props.getSalesTax({service_uuid: rows[index].service_uuid, amount: rows[index].price*(rows[index].quantity?rows[index].quantity:1), item_type: rows[index].type})
        } else if (isEmpty(rows[index].price)) {
          rows[index].tax = 0
          this.setState({rows}, () => this.calculateTotal())
        }
      })
      if(e.target.name==="service_uuid"){
        this.setState({
          service_uuid:e.target.value,
          selectWorkOrder:true,
          loader:true
        })
        const params = this.filterParams(e.target.value);
        this.props.getWorkOrderDetail(params)
      }
    }
  }

    //Remove null object properties
    filterParams = (params) => {
      for (var propName in params) {
        if (params[propName] === "" || params[propName] === null || params[propName] === "null" || params[propName] === undefined || params[propName] === "undefined") {
          delete params[propName];
        }
      }
      return params
    }

  // calculate total
  calculateTotal = () => {
    let { rows, amount_received,credit_memo_amount_applied } = this.state;
    let new_total = 0, salesTax = 0, balance_due = this.state.balance_due, quantity = 1, refund_amount = 0;
    map(rows, x => {
      salesTax = parseFloat(salesTax) + parseFloat(x?.tax)
      new_total = parseFloat(new_total) + (parseFloat(x.price || 0)*parseInt(x.quantity || 1))
      // balance_due = parseFloat(balance_due) + ((parseFloat(x.price || 0)*parseInt(x.quantity || 1)) + parseFloat(x.tax || 0))
      quantity = parseInt(x.quantity || 1)
      refund_amount = parseFloat(refund_amount) + parseFloat(x.refund_amount?x.refund_amount:0)
    })
    balance_due =  (parseFloat(new_total)+parseFloat(salesTax))-parseFloat(amount_received);
    this.setState({balance_due, total: new_total, sales_tax: salesTax, quantity:quantity,refund_amount:refund_amount.toFixed(2) })
  }

  // on delete row
  onDeleteRow = (item) => {
    if(item==="clear"){
      this.onClearAll();
      setTimeout(() => { this.toggleDeleteModal() }, 500)
    }else{
      const { rows,deletedWorkOrder } = this.state;
      let DW  = deletedWorkOrder;
      let filterWorkOrder = rows.filter(function( obj ) { 
        return obj.service_uuid === item.service_uuid;
      });
      DW = DW.concat(filterWorkOrder);
      let filterRows = rows.filter(function( obj ) { 
        return obj.service_uuid !== item.service_uuid;
      });
      if(filterRows.length === 0){
        filterRows =  [{ service_uuid: '', type: '', date: '', description: '',quantity:1, price: '', taxChecked: false, tax: '',isEditRow:true }]
      }
      this.setState({ rows:filterRows , deletedWorkOrder:DW }, () => { this.calculateTotal(); })
      setTimeout(() => { this.toggleDeleteModal() }, 500)
      this.setState({isGenerateInvoiceVisible:true})
    }
  }

  onDiscardServiceOrder= (e) => {
    const {serviceOrderNumberList} = this.state;
    this.setState({ 'service_order_uuid': e })
    const serviceList = serviceOrderNumberList?.data?.find(x => x.uuid === e)
    let filterList= serviceList?.services.filter(function( obj ) { 
      return obj.invoice_status === '';
      // return obj.status==='cancelled'?obj.bill_for_cancelization===true && obj.is_auto_invoice_genrated ===false && obj.is_manual_invoice_generated === false:obj.is_auto_invoice_genrated ===false && obj.is_manual_invoice_generated === false;
    });
    this.setState({ 'serviceList': filterList })
    this.setState({
      rows: [{ service_uuid: '', type: '', date: '', description: '',quantity:1, price: '', taxChecked: false, tax: '' }]
    })
    setTimeout(() => { this.toggleDeleteModal() }, 500)
  }

  // on add item
  onAddItem = () => {
    const { rows } = this.state;
    rows.push({ service_uuid: '', type: '', date: '', description: '',quantity:1, price: '', taxChecked: false, tax: '' })
    this.setState({ rows })
  }

  // on add item
  onClearAll = () => {
    if(this.props.invoice_uuid){
      let rowsFilter= this.state.rows.filter(function( rf ) { 
        return rf.isEditRow === false;
      });
      this.setState({rows:rowsFilter})
    }else{
      this.setState({ rows: [{ service_uuid: '', type: '', date: '', description: '',quantity:1, price: '', taxChecked: false, tax: '' }] }, () => { this.calculateTotal(); })
    }
  }

  // on service order change
  onServiceOrderChange = (e) => {
    if(this.state.service_order_uuid!=="" && this.state.service_order_uuid!==e){
      this.toggleDeleteModal(e,"sd")
    }else{
      const {serviceOrderNumberList, rows} = this.state;
      this.props.getServiceOrderById(e)
      this.props.getInvoiceDescription(e)
      this.setState({ 'service_order_uuid': e })
      const serviceList = serviceOrderNumberList?.data?.find(x => x.uuid === e)
      map(rows, x => {
        // x.isEditRow = true
        const service_num = serviceList?.services?.find(y => y.uuid === x.service_uuid)
        if (isEmpty(service_num)) {
          x.service_uuid = ''
          x.service_code = ''
        }
      })
      let filterList = serviceList?.services.filter(function( obj ) { 
        return obj.invoice_status === '';
        // return obj.status==='cancelled'?obj.bill_for_cancelization===true && obj.is_auto_invoice_genrated ===false && obj.is_manual_invoice_generated === false:obj.is_auto_invoice_genrated ===false && obj.is_manual_invoice_generated === false;
      });
      this.setState({ 'serviceList': filterList, rows })
    }
  }

  // validate required fields
  validate = () => {
    const { rows, invoice_date, due_date, service_order_uuid } = this.state;

    const schema = yup.object().shape({
      service_order_uuid: yup.string().required('Service order# is required'),
      rows: yup.array(yup.object({
        service_uuid: yup.string().required('Service#  is required'),
        type: yup.string().required('Type is required'),
        date: yup.string().required('Date is required'),
        description: yup.string().required('Description is required'),
        // other_description: yup.string().when('description', {
        //   is: 'other',
        //   then: yup.string().required('Other Description is required'),
        // }),
        price: yup.string().test('match', 'Price should have a valid format', (price) => {
          return !isNaN(parseFloat(price))
        })
      })),
      invoice_date: yup.string().required('Invoice Date is required'),
      due_date: yup.string().required('Due Date is required').test("compare", "Invalid due date", (due_date) => moment(this.state.invoice_date).isBefore(moment(due_date))),
    });

    const schema1 = yup.object().shape({
      service_order_uuid: yup.string().required('Service order# is required'),
      invoice_date: yup.string().required('Invoice Date is required'),
      due_date: yup.string().required('Due Date is required').test("compare", "Invalid due date", (due_date) => moment(this.state.invoice_date).isBefore(moment(due_date))),
    });

    const data = { service_order_uuid, rows, invoice_date, due_date };

    setTimeout(() => {
      this.props.invoice_uuid?schema1.validate(data, { abortEarly: false }).then(() => {
        this.setState({ btn_active: true, errors: {} })
        this.onSave();
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => { err_data[item.path] = item.message })
        this.setState({ errors: err_data, is_btn_active: false,did_click:false })
      }):schema.validate(data, { abortEarly: false }).then(() => {
        this.setState({ btn_active: true, errors: {} })
        this.onSave();
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => { err_data[item.path] = item.message })
        this.setState({ errors: err_data, is_btn_active: false,did_click:false })
      });
    }, 500)
  };

  // on save
  onSave = () => {
    const { 
      invoice_date,
      due_date,
      description,
      serviceOrder,
      quantity ,balance_due,
      amount_received,
      service_order_uuid,
      rows,
      deletedWorkOrder,
      isApprove
    } = this.state;
    const { addInvoice, customerId,addManualInvoice } = this.props;
    const address = !isEmpty(serviceOrder?.billing_address) ? serviceOrder?.billing_address : !isEmpty(serviceOrder?.service_address) ? serviceOrder?.service_address : {};

    if (!address?.geo_location) {
      delete address?.geo_location
    }
    map(rows,(r,i)=>{
      r.date=this.localToUTC(due_date).format('YYYY-MM-DD')
      r.item_type = r.type
    })
    let uniqueRows = [...new Set(rows.map(item => item.service_uuid))];
    let workOrders = [];
    map(uniqueRows, (ur, i1) => {
      let obj = {};
      obj.work_order = ur;
      let lineItems = rows.filter(function( obj ) { 
        return obj.service_uuid ===ur;
      });
      obj.isEditRow = lineItems[0].isEditRow;
      obj.line_items = lineItems;
      workOrders.push(obj);
    });
    let deleteFilter= deletedWorkOrder.filter(function( df ) { 
      return df.isEditRow === false;
    });
    let DelWorkOrder = _.uniqBy(deleteFilter, 'service_uuid');
    DelWorkOrder = _.map(DelWorkOrder, 'service_uuid');
    let isInvoiceProcessed = false;
    if(this.props.invoice_uuid==='' && isApprove===false){
      isInvoiceProcessed = false;
    }
    if(this.props.invoice_uuid==='' && isApprove===true){
      isInvoiceProcessed = true;
    }
    if(this.props.invoice_uuid!=='' && isApprove===false){
      isInvoiceProcessed = false;
    }
    if(this.props.invoice_uuid!=='' && isApprove===true){
      isInvoiceProcessed = true;
    }

    addManualInvoice({
      user_uuid: customerId,
      invoice_date: invoice_date ? this.localToUTC(invoice_date).format('YYYY-MM-DD') : null,
      due_date: due_date ? this.localToUTC(due_date).format('YYYY-MM-DD') : null,
      // total: parseFloat(total || '0').toFixed(2),
      balance_due: parseFloat(balance_due || '0').toFixed(2),
      quantity:quantity,
      amount_received: parseFloat(amount_received || '0').toFixed(2),
      // sales_tax: parseFloat(sales_tax || '0').toFixed(2),
      status: 'open',
      billing_address: address,
      billing_type: 'email',
      notes: description,
      service_order_uuid: service_order_uuid,
      invoice_uuid:this.props.invoice_uuid?this.props.invoice_uuid:null,
      is_process:isInvoiceProcessed,
      work_orders:workOrders.filter(function( wo ) { 
        return wo.isEditRow === true && wo.work_order!=="";
      }),
      delete_work_orders:this.props.invoice_uuid?DelWorkOrder:[]
    });

    // addInvoice({
    //   user_uuid: customerId,
    //   invoice_date: invoice_date ? this.localToUTC(invoice_date).format('YYYY-MM-DD') : null,
    //   due_date: due_date ? this.localToUTC(due_date).format('YYYY-MM-DD') : null,
    //   // total: parseFloat(total || '0').toFixed(2),
    //   balance_due: parseFloat(balance_due || '0').toFixed(2),
    //   quantity:quantity,
    //   amount_received: parseFloat(amount_received || '0').toFixed(2),
    //   // sales_tax: parseFloat(sales_tax || '0').toFixed(2),
    //   status: 'open',
    //   billing_address: address,
    //   billing_type: 'email',
    //   notes: description,
    //   service_order_uuid: service_order_uuid,
    // })

    this.setState({ description_data: [],selectWorkOrder:false,loader:true });
  }

  // render Item Row
  renderItemRow = (item, index) => {
    const is_payment_recieved = Number(this.state.amount_received || "0") > 0
    const { serviceList, errors, description_data } = this.state;
    let workOrder = serviceList?serviceList.find(element => element.uuid === item.service_uuid):null;
    var getKeys = _.map(this.state.rows, 'service_uuid');
    getKeys = [...new Set(getKeys)];
    let filterServiceList = serviceList?serviceList.filter(x => !getKeys.includes(x.uuid)):[];
    const is_not_editable = (((is_payment_recieved) && ((is_payment_recieved) && this.state.invoiceDetail?.status!=='draft')) || this.state.invoiceDetail?.status === 'open');

    return (
      <div className="divrow editrow" key={`items${index}`} style={{marginLeft: "0px"}}>
        {item?.service_uuid ? <div className="dcell sno">{workOrder?.service_code?workOrder?.service_code:item?.service_code}</div>
          :
          <div className="dcell sno">
            <Select
              disabled={item?.service_uuid?true:false}
              dropdownClassName="sm-filter"
              showArrow
              name={'service_uuid'}
              virtual={false}
              style={{ width: '100%' }}
              value={item?.service_uuid ? item?.service_uuid : undefined}
              placeholder={'Select'}
              onChange={(e) => {
                this.onRowDataChange({ target: { name: 'service_uuid', value: e } }, index)
              }}
            >
              {map(filterServiceList, (obj) => <Option value={obj?.uuid} key={obj?.uuid}>{obj?.service_code}</Option>)}
            </Select>
            {errors?.[`rows[${index}].service_uuid`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].service_uuid`]}</label> : ''}
          </div>
        }
        <div className="dcell sdate">{item?.date ?item?.date : "--"}
          {/* <DatePicker
            disabled={true}
            inputReadOnly
            style={{ 'width': '100%' }}
            name='date'
            format="MM/DD/YYYY"
            allowClear={false}
            value={item?.date ? this.UTCToLocal(item?.date) : null}
            onChange={(e) => this.onRowDataChange({ target: { name: 'date', value: e } }, index)}
          />
          {errors?.[`rows[${index}].date`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].date`]}</label> : ''} */}
        </div>
        <div className="dcell stype">{item?.type ? item?.type : "--"}
          {/* <Select
            disabled={true}
            dropdownClassName="sm-filter"
            showArrow
            name={'type'}
            virtual={false}
            style={{ width: '100%' }}
            value={item?.type ? item?.type : undefined}
            placeholder={'Product/Service'}
            onChange={(e) => { this.onRowDataChange({ target: { name: 'type', value: e } }, index) }}
          >
            <Option value="product">Product</Option>
            <Option value="service">Service</Option>
          </Select>
          {errors?.[`rows[${index}].type`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].type`]}</label> : ''} */}
        </div>
        <div className="dcell sdesc">{item.description ? item.description : item.sub_description?item.sub_description:"--"}
          {/* <Select
            disabled={true}
            value={item.description ? item.description : "Please Select"}
            placeholder="Please Select"
            onChange={(e) => { this.onRowDataChange({ target: { name: 'description', value: e } }, index) }}
          >
            {description_data?.data?.filter(data => data?.type === item?.type).map((item) => {
              return (
                <Option key={item.item}>{item.item}</Option>
              )
            })}
            <Option key="other">Other</Option>
          </Select>
          {errors?.[`rows[${index}].description`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].description`]}</label> : ''}
          {item.description === "other" ?
            <>
              <textarea
                disabled={true}
                className="sdesc mt-20"
                value={item.other_description}
                onChange={(e) => { this.onRowDataChange({ target: { name: 'other_description', value: e.target.value } }, index) }}
              ></textarea>
              {errors?.[`rows[${index}].other_description`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].other_description`]}</label> : ''}
            </>
            : null
          } */}
        </div>
        {item?.type==="product"?<div className="dcell sprice">{item?.quantity}
          {/* <div className="sprice">
            <input
              readOnly={true}
              // readOnly={item?.type==="service"?true:false}
              type="text"
              className="form-control"
              value={item?.quantity}
              name="quantity"
              onChange={(e) => this.onNumericInputChange(e.target.value) && this.onRowDataChange({ target: { name: 'quantity', value: e.target.value } }, index)}
              placeholder="Quantity" />
            {errors?.[`rows[${index}].quantity`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].quantity`]}</label> : ''}
          </div> */}
        </div>:<div className="dcell sprice">{item?.service_uuid?1:0}
          {/* <div className="sprice">
            <input
              readOnly={true}
              type="text"
              className="form-control"
              value={1}
              name="quantity"
              onChange={(e) => this.onNumericInputChange(e.target.value) && this.onRowDataChange({ target: { name: 'quantity', value: e.target.value } }, index)}
              placeholder="Quantity" />
            {errors?.[`rows[${index}].quantity`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].quantity`]}</label> : ''}
          </div> */}
        </div>}
        <div className="dcell sprice">${formatToCurrency(item?.price)}
          {/* <div className="sprice">
            <input
              readOnly={true}
              type="text"
              className="form-control"
              value={item?.price}
              name="price"
              onChange={(e) => this.onNumericInputChange(e.target.value) && this.onRowDataChange(e, index)}
              placeholder="Price" />
            {errors?.[`rows[${index}].price`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].price`]}</label> : ''}
          </div> */}
        </div>  
        <div className="dcell stax">
          <div className="flex ai-center">
            
            <div className="inline-check-list sm-checks">
              <div className="flex ai-center">
                <div className="sprice"> 
                  ${formatToCurrency(item?.tax)}
                </div>
              </div>
              {/* <div className="fitem-check">
                <input
                  type="checkbox"
                  className="fitem-ck-input"
                  id={`taxChecked${index}`}
                  name="taxChecked"
                  checked={item?.taxChecked}
                  onChange={(e) => { this.onRowDataChange(e, index, 'bool'); this.onRowDataChange({ target: { name: 'tax', value: '' } }, index) }} />
                <label htmlFor={`taxChecked${index}`} className="fitem-ck-txt"></label>
              </div>
              {
                item?.taxChecked ? <input
                  type="text"
                  className="form-control"
                  value={item?.tax}
                  name="tax"
                  onChange={(e) => (e.target.value.indexOf('%') > 0 || this.onNumericInputChange(e.target.value)) && this.onRowDataChange(e, index)}
                  placeholder="Tax" /> : ''} */}
            </div>
          </div>
          {(this.props.invoice_uuid && this.state.invoiceDetail?.status!=='draft') || (this.state.rows.length===1 && this.props.invoice_uuid==='') ? null:<i className="las la-trash-alt" onClick={() => this.toggleDeleteModal(item,"wd")} />}
        </div>
      </div>
    )
  }

  // render table
  renderItemTable = () => {
    const { rows, description, total, sales_tax, amount_received, balance_due,refund_amount, credit_memo_amount_applied } = this.state;
    const is_payment_recieved = Number(amount_received || "0") > 0;
    const is_not_editable = ((is_payment_recieved) && ((is_payment_recieved) && this.state.invoiceDetail?.status!=='draft')) || this.state.invoiceDetail?.status === 'open';

    return (
      <React.Fragment>
        <div className="table-block">
          <div className="div-table">
            <div className="divhead">
              <div className="dcell sno">Work Order #</div>
              <div className="dcell sdate">Date</div>
              <div className="dcell stype">Type</div>
              <div className="dcell sdesc">Description</div>
              <div className="dcell squantity">Quantity</div>
              <div className="dcell sprice">Price</div>
              <div className="dcell stax">Tax</div>
            </div>
            <div className="divbody">
              {map(rows, this.renderItemRow)}
              <div className="divrow dfoot">
                <div className="dcell">
                  <div className="btn-group">
                    <button className={`btn btn-warning ${this.state.invoiceDetail?.status && this.state.invoiceDetail?.status!=='draft' ? "disbale_btn" : ""}`} disabled={this.state.invoiceDetail?.status && this.state.invoiceDetail?.status!=='draft'} onClick={() => this.onAddItem()}><i className="las la-plus-circle"></i> Add Item</button>
                    <a className={`clear-item btn-warning  ${(this.state.invoiceDetail?.status && this.state.invoiceDetail?.status!=='draft') || rows.length===1 ? "disbale_btn" : ""}`} disabled={this.state.invoiceDetail?.status && this.state.invoiceDetail?.status!=='draft'} onClick={() => (this.state.invoiceDetail?.status && this.state.invoiceDetail?.status!=='draft') || rows.length===1 ? null:this.toggleDeleteModal("clear","wd")}>Clear All Items</a>

                  </div>
                  <div className="form-group">
                    <div className="fitem">
                      <textarea
                        disabled={this.state.invoiceDetail?.status && this.state.invoiceDetail?.status!=='draft'}
                        rows="2"
                        className="form-control"
                        name="description"
                        placeholder={"Add a message to your invoice !"}
                        value={description}
                        onChange={(e) => this.onTextChange(e)} />
                    </div>
                  </div>
                </div>
                <div className="dcell flex ai-start flex-end">
                  <div className="price-block">
                    <span>Total</span>
                    <span>Sales Tax</span>
                    <span>Amount Received</span>
                    <span>Credit Applied</span>
                    {this.state.invoiceDetail?.status!=='draft' && this.props.invoice_uuid!==''?<span>Balance Due</span>:null}
                    <span>Amount Refunded</span>
                  </div>
                  <div className="pricing">
                    <span>${total ? formatToCurrency(total) : '0.00'}</span>
                    <span>${sales_tax ? formatToCurrency(sales_tax) : '0.00'}</span>
                    <span>${amount_received ? formatToCurrency(amount_received) : '0.00'}</span>
                    <span>${credit_memo_amount_applied ? formatToCurrency(credit_memo_amount_applied) : '0.00' }</span>
                    {this.state.invoiceDetail?.status!=='draft' && this.props.invoice_uuid!==''?<span>${balance_due ? formatToCurrency(balance_due) : '0.00'}</span>:null}
                    <span>${this.state.invoiceDetail && this.state.invoiceDetail.refund_amount ? formatToCurrency(this.state.invoiceDetail?.refund_amount) : '0.00'}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }

  render() {
    const { loader, invoice_date, due_date, serviceOrder, errors, serviceOrderNumberList, service_order_uuid,rows, did_click } = this.state;
    const { onChangeView, customer } = this.props;
    const is_payment_recieved = Number(this.state.amount_received || "0") > 0
    const is_new = this.props.invoice_uuid === '' ? true : false;
    const is_new_with_rows = parseFloat(this.state.total)>0?true:false;
    const is_service_order = !isEmpty(serviceOrder?.billing_address) || !isEmpty(serviceOrder?.service_address)
    const address = !isEmpty(serviceOrder?.billing_address) ? serviceOrder?.billing_address : !isEmpty(serviceOrder?.service_address) ? serviceOrder?.service_address : {};
    let rowsFilter= rows.filter(function( rf ) { 
      return rf.isEditRow === true;
    });
    const is_edit = rowsFilter.length>0 ?true:false;
    const is_date_selected =  (due_date !== null && due_date!== "") && (invoice_date !== null && invoice_date!== "") ?true:false;
    const disabledButton = is_new ? is_new_with_rows ? did_click ? is_date_selected ? true : false :false : true : is_edit ? did_click ? true : false : this.state.invoiceDetail?.status === 'draft' ? did_click ? true : false : is_payment_recieved || this.state.invoiceDetail?.status !== 'draft' ? true : false;
    const disabledButtonGenerate =(parseFloat(this.state.total)>0 && rowsFilter.length>0) && (this.state.invoiceDetail?.status==='draft' || this.props.invoice_uuid==='')?false:true;
    
    return (
      <React.Fragment>
        {loader && <Loader />}
        <div className="filter_wrapper">
          <ul className="breadcrumb">
            <li className={"cursor_pointer"}><span onClick={() => { onChangeView(0) }}>Back to all invoices</span></li>
          </ul>
        </div>
        <div className="invoice-container">
          <div className="flex flex-service">
            <div className="flex-1">
              <div className="bill-add">
                <b>Bill to:</b>
                <p>{customer?.first_name} {customer?.last_name}, <br />{is_service_order ? `${address?.address},` : ''} <br />{is_service_order ? `${address?.city}, ${address?.state}, ${address?.zip_code}` : ''}</p>
              </div>
            </div>
            <div className="flex-1">
              <div className="form-group">
                <div className="half-fitem fitem">
                  <div className="half-fitem fitem">
                    <label><b>Service Order#</b></label>
                    <Select
                      dropdownClassName="sm-filter"
                      disabled={this.props.invoice_uuid?true:false}
                      showArrow
                      name={'service_order'}
                      virtual={false}
                      style={{ width: '100%' }}
                      value={service_order_uuid ? service_order_uuid : undefined}
                      placeholder={'Service Order#'}
                      onChange={(e) => this.onServiceOrderChange(e)}
                    >
                      {map(serviceOrderNumberList?.data, (obj) => <Option value={obj?.uuid} key={obj?.uuid}>{obj?.service_order_number}</Option>)}
                    </Select>
                    {errors?.['service_order_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['service_order_uuid']}</label> : ''}
                  </div>
                  <div className="half-fitem fitem">
                    <label><b>Invoice Date</b></label>
                    <DatePicker
                      disabled={this.state.invoiceDetail?.status && this.state.invoiceDetail?.status!=='draft'}
                      inputReadOnly
                      style={{ 'width': '100%' }}
                      // disabledDate={(current) => { return current && current <= moment().endOf('day'); }}
                      name='date'
                      format="MM/DD/YYYY"
                      allowClear={false}
                      value={invoice_date ? this.UTCToLocal(invoice_date) : null}
                      onChange={(e) => this.onTextChange({ target: { name: 'invoice_date', value: e } })}
                    />
                    { errors?.['invoice_date'] ? <label className="new_err_msg"><i className="las la-info-circle" />{
                      !errors?.['invoice_date'].includes("invoice_date must be a `string` type, but the final value was:") ? errors?.['invoice_date'] ? errors?.['invoice_date'] : '' : 'Invoice date is required'
                    }</label> : ''}
                  </div>
                  <div className="half-fitem fitem">
                    <label><b>Due Date</b></label>
                    <DatePicker
                      disabled={this.state.invoiceDetail?.status && this.state.invoiceDetail?.status!=='draft'}
                      inputReadOnly
                      style={{ 'width': '100%' }}
                      disabledDate={(current) => { return current && current <= moment().endOf('day'); }}
                      name='date'
                      format="MM/DD/YYYY"
                      allowClear={false}
                      value={due_date ? this.UTCToLocal(due_date) : null}
                      onChange={(e) => this.onTextChange({ target: { name: 'due_date', value: e } })}
                    />
                    {errors?.['due_date'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['due_date']}</label> : ''}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.renderItemTable()}
          <div className="sticky-btn-grp">
            <div className="flex ai-center">
              <div className="flex-1">
                <button disabled={disabledButtonGenerate} className={disabledButtonGenerate?`btn btn-disabled disbale_btn`: `btn btn-warning`} onClick={() => rowsFilter.length>0 || this.state.invoiceDetail?.status!=='draft'?this.validate():null}>Generate Invoice</button>
                <button disabled={disabledButton} className={ disabledButton?`btn btn-disabled disbale_btn`: `btn btn-warning`} onClick={() =>  parseFloat(this.state.total)>0?this.setState({ isApprove: true, did_click:true }, () => this.validate()):null}>Generate,Process & Email Invoice</button>

              </div>
            </div>
          </div>
        </div>
        <Modal
          title="Delete Work Order"
          visible={this.state.showDelete}
          onCancel={() => this.toggleDeleteModal()}
          className="delete_user_modal"
          width={400}
          footer={[
            <button key="cancel" className="btn btn-brand btn-bdr" onClick={() => this.toggleDeleteModal()}>No</button>,
            <button key="upload" className={`btn btn-waning`} onClick={() => this.state.selectedDeletedType==="wd"?this.onDeleteRow(this.state.selectedDeletedItem):this.onDiscardServiceOrder(this.state.selectedDeletedItem)}>Yes</button>,
          ]}
        >
          <div>
            <p>{this.state.selectedDeletedType==="wd"?'Are you sure you want to delete the selected Work Order from this invoice?':'Upon selecting a new service order while creating a manual invoice - Do you wish to discard the changes for the selected service order!'}</p>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

export default AddNewInvoice;
